import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IRecordNavigationTimingParams {
  // See: http://www.w3.org/TR/navigation-timing/#sec-navigation-timing-interface
  timing: PerformanceTiming;
}

export class RecordNavigationTimingRequest extends Request<IRecordNavigationTimingParams, IResult> {
  constructor(params: IRecordNavigationTimingParams) {
    super('recordNavigationTiming', params);
  }
}
